var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-tooltip",
    {
      attrs: { bottom: "" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function({ on }) {
            return [
              _c(
                "v-chip",
                _vm._g(
                  _vm._b(
                    {
                      staticStyle: { cursor: "pointer" },
                      attrs: { small: "" },
                      on: { click: _vm.handleItemClick }
                    },
                    "v-chip",
                    _vm.$attrs,
                    false
                  ),
                  on
                ),
                [_vm._v("\n      N°" + _vm._s(_vm.requestId) + "\n    ")]
              )
            ]
          }
        }
      ])
    },
    [
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "\n    " + _vm._s(_vm.generateMessage("requests.item.link")) + "\n  "
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }